module.exports = __webpack_public_path__ + "assets/1ce2b774c0c5e26dd9e432ccd708b507.png";